import { render, staticRenderFns } from "./registerSectorStep1Page.vue?vue&type=template&id=655a2535&scoped=true"
import script from "./registerSectorStep1Page.vue?vue&type=script&lang=js"
export * from "./registerSectorStep1Page.vue?vue&type=script&lang=js"
import style0 from "./registerSectorStep1Page.vue?vue&type=style&index=0&id=655a2535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a2535",
  null
  
)

export default component.exports